import React from "react";
import ForgotPassword from "../../components/UserForgotPassword/ForgotPassword";

function UserForgotPasswordPage() {
  return (
    <div>
    <ForgotPassword />
    </div>
  );
}

export default UserForgotPasswordPage;
